import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ToolsSection from "@/components/ToolsSection";
import CreateSection from "@/components/CreateSection";
import AdiciopComponent from "@/components/AdiciopComponent";
import VispunkSection from "@/components/VispunkSection";
import LeonardoAISection from "@/components/LeonardoAISection";
import NeobuxSection from "@/components/NeobuxSection";
import MelhoresSitesSection from "@/components/MelhoresSitesSection";
import LivesSection from "@/components/LivesSection";
import HotmartSection from "@/components/HotmartSection";
import MegazoneDownloadsSection from "@/components/MegazoneDownloadsSection";
import SitesUsadosSection from "@/components/SitesUsadosSection";
import JogosSection from "@/components/JogosSection";
import LipSyncSection from "@/components/LipSyncSection";
import TranslateSection from "@/components/TranslateSection";
import DesignToolsSection from "@/components/DesignToolsSection";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <HeroSection />
        <MelhoresSitesSection />
        <SitesUsadosSection />
        <JogosSection />
        <LipSyncSection />
        <TranslateSection />
        <DesignToolsSection />
        <LivesSection />
        <MegazoneDownloadsSection />
        <HotmartSection />
        <ToolsSection />
        <CreateSection />
        <VispunkSection />
        <LeonardoAISection />
        <NeobuxSection />
        <AdiciopComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Home;